export enum CsrdSingleMatterViewMaterialityTypePath {
  IMPACT = 'impact',
  FINANCIAL = 'financial',
}
